import gql from 'graphql-tag';

/**
 * Data of the block project-customer-installation-address. Read through
 * `Project.blocks.customerInstallationAddress`, which checks the block's read permission.
 */
export const PROJECT_CUSTOMER_INSTALLATION_ADDRESS_FIELDS = gql`
  fragment projectCustomerInstallationAddressFields on ProjectCustomerInstallationAddressBlock {
    id
    number
    installationAddressState
    installationAddress {
      street
      streetNumber
      streetNumberSuffix
      zip
      city
      cityPart
    }
    customer {
      longitude
      latitude
    }
  }
`;
